// @ts-expect-error not typed
import { createUpdateFocusedItem } from 'ContentEditorUI/redux/actions/baseFocusActions';
// @ts-expect-error not typed
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
// @ts-expect-error not typed
import { setScrollTo } from 'ContentEditorUI/redux/actions/baseSettingsActions';
import { KB_MODAL_TYPES } from '../../types/ModalTypes';
const ARTICLE_SETTINGS_REDUX_FIELDS = ['audienceAccess', 'category', 'lang', 'metaDescription', 'slug', 'subcategory', 'tags', 'title'];
const articleFocusLogic = (focusedItem, dispatch, state, options) => {
  if (ARTICLE_SETTINGS_REDUX_FIELDS.includes(focusedItem)) {
    dispatch(openModal(KB_MODAL_TYPES.SETTINGS_MODAL));
    dispatch(setScrollTo(options.settingsModalQuery));
  }
};
export const updateFocusedItem = createUpdateFocusedItem(articleFocusLogic);